var map = {
	"./10_yellow.mp3": "1320",
	"./11_green.mp3": "93d5",
	"./8_blue.mp3": "e7a3",
	"./9_red.mp3": "32f7",
	"./M_Brilliant.mp3": "9f36",
	"./M_Excellent.mp3": "3824",
	"./M_Fantastic.mp3": "811c",
	"./M_Great.mp3": "d63e",
	"./M_Perfect.mp3": "470c",
	"./M_Think again.mp3": "0cf6",
	"./M_Try again.mp3": "a34b",
	"./M_Very good.mp3": "3ae1",
	"./M_Well done.mp3": "73b5",
	"./M_Work harder.mp3": "e7a30",
	"./click.mp3": "fb68"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a905";